export const convertFilter = (queryParams) => {
  const {sortOrder, sortField, pageNumber, pageSize, filter} = queryParams;
  return {
    ...filter,
    "pageInfo.curPage": pageNumber,
    "pageInfo.pageSize": pageSize,
    "pageInfo.sortNm": sortField,
    "pageInfo.sort": sortOrder
  };
}
